import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { areEqual } from 'Utils/equalityChecks';

import { DeleteMoistureLogModal } from 'Components/RocketDry';

import { deleteDryingLog } from 'Containers/RocketDry/actions';

import { useRocketDryFunctions } from 'Context/RocketDry';

const DeleteMoistureLogModalContainer = () => {
  const dispatch = useDispatch();

  const {
    isDeleteMoistureLogModalOpen,
    setIsDeleteMoistureLogModalOpen,
    selectedMoistureLog,
    setSelectedMoistureLog,
    selectedDamageMaterial,
    setSelectedDamageMaterial,
    setMoistureLogRefetch,
  }: any = useRocketDryFunctions();

  const onCloseModal = useCallback(() => {
    setIsDeleteMoistureLogModalOpen(false);
    setSelectedMoistureLog(undefined);
    setSelectedDamageMaterial(undefined);
  }, []);

  const onDeleteButtonClick = useCallback(async () => {
    await dispatch(deleteDryingLog(selectedMoistureLog.id));
    setMoistureLogRefetch(true);
    onCloseModal();
  }, [selectedMoistureLog]);

  return (
    <DeleteMoistureLogModal
      isOpen={isDeleteMoistureLogModalOpen}
      moistureLog={selectedMoistureLog}
      damageMaterial={selectedDamageMaterial}
      closeModal={onCloseModal}
      onDeleteButtonClick={onDeleteButtonClick}
    />
  );
};

const DeleteMoistureLogModalContainerMemo = memo(DeleteMoistureLogModalContainer, areEqual);

export { DeleteMoistureLogModalContainerMemo as DeleteMoistureLogModal };
